import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth, ensureUserProfileDocument, isAdmin } from "../firebase";

export default function RequireAdmin({ children }) {
  const [user, authLoading] = useAuthState(auth);
  const [adminAllowed, setAdminAllowed] = useState(null);
  const location = useLocation();

  useEffect(() => {
    let active = true;

    if (authLoading) return () => { active = false; };
    if (!user) {
      setAdminAllowed(false);
      return () => { active = false; };
    }

    setAdminAllowed(null);
    ensureUserProfileDocument(user)
      .then(() => isAdmin(user.uid))
      .then((allowed) => {
        if (active) setAdminAllowed(Boolean(allowed));
      })
      .catch((error) => {
        console.error("No se pudo validar el acceso de administrador:", error);
        if (active) setAdminAllowed(false);
      });

    return () => {
      active = false;
    };
  }, [authLoading, user]);

  if (authLoading || (user && adminAllowed === null)) {
    return <p>Cargando...</p>;
  }

  if (!user || !adminAllowed) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return children;
}
